module.exports = __webpack_public_path__ + "static/media/conservatism2.d80417cb.jpg";